import kuikPos from './kuikPos';

export default kuikPos;
